import { notifications } from '@mantine/notifications';
import { getActivitiesKey, useCreateActivity } from 'api-hooks/activity';
import { NavigationRoutes } from 'common/constants';
import { PreviousNavigation } from 'common/helpers/previous-navigation';
import { queryClient } from 'common/repositories/query-client';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';

import ActivityForm from './components/form';

export default function ActivityCreate() {
  const { navigate, back } = useNavigation();
  const createMutation = useCreateActivity();
  const permission = useGetCrudPermission('activities');

  return (
    <ActivityForm
      saveMutation={createMutation}
      onSubmit={async (input) => {
        const result = await createMutation.mutateAsync(input);

        queryClient.refetchQueries([getActivitiesKey()[0]]);

        const prevPath = PreviousNavigation.get();
        if (prevPath) {
          PreviousNavigation.remove();
          back();
        } else if (permission.view) {
          navigate(NavigationRoutes.ActivitiesView, {
            id: result.data?.id,
          });
        }

        notifications.show({ message: result?.message, color: 'green' });

        return result.data;
      }}
    />
  );
}
